import { IAPIContext } from 'models/context/api-context';
import { ErrorMessageResponse, Convert as ErrorMessageResponseConvert } from 'models/schema-generated-models/api-response-bodies/error-message-response';
import {
    SSOAPIBadRequest,
    SSOAPIServerError,
    SSOAPIUnexpectedResponseBody,
    SSOAPIUnexpectedResponseStatus,
    SSOAPIUserInsufficientPermissionsError,
    SSOAPIUserSessionInvalidError
} from 'services/errors';
import { Client } from './client/client';
import { ClientResponse } from './client/client-response';

export abstract class BaseService {
    constructor(protected client: Client) {}

    protected processGeneralAPIError(response: ClientResponse, body: string, responseAPIContext: IAPIContext): Error {
        if (![400, 401, 403, 500, 502].includes(response.status)) {
            return new SSOAPIUnexpectedResponseStatus(responseAPIContext, `SSO API returned an unexpected response status code of ${response.status}`, {
                requestStartTimeMS: response.requestStartTimeMS,
                requestEndTimeMS: response.requestEndTimeMS,
                requestExecutionTimeMS: response.requestExecutionTimeMS
            });
        }

        let errorBody: ErrorMessageResponse;

        try {
            errorBody = ErrorMessageResponseConvert.toErrorMessageResponse(body);
        } catch (err) {
            return new SSOAPIUnexpectedResponseBody(responseAPIContext, 'Unexpected response body from error return.', {
                requestStartTimeMS: response.requestStartTimeMS,
                requestEndTimeMS: response.requestEndTimeMS,
                requestExecutionTimeMS: response.requestExecutionTimeMS
            });
        }

        switch (response.status) {
            case 400:
                return new SSOAPIBadRequest(errorBody, responseAPIContext, 'Bad request error.', {
                    requestStartTimeMS: response.requestStartTimeMS,
                    requestEndTimeMS: response.requestEndTimeMS,
                    requestExecutionTimeMS: response.requestExecutionTimeMS
                });
            case 401:
                return new SSOAPIUserSessionInvalidError(errorBody, responseAPIContext, 'User session invalid error.', {
                    requestStartTimeMS: response.requestStartTimeMS,
                    requestEndTimeMS: response.requestEndTimeMS,
                    requestExecutionTimeMS: response.requestExecutionTimeMS
                });
            case 403:
                return new SSOAPIUserInsufficientPermissionsError(errorBody, responseAPIContext, 'User insufficient permissions error.', {
                    requestStartTimeMS: response.requestStartTimeMS,
                    requestEndTimeMS: response.requestEndTimeMS,
                    requestExecutionTimeMS: response.requestExecutionTimeMS
                });
            case 500:
            case 502:
                return new SSOAPIServerError(errorBody, responseAPIContext, 'Server error.', {
                    requestStartTimeMS: response.requestStartTimeMS,
                    requestEndTimeMS: response.requestEndTimeMS,
                    requestExecutionTimeMS: response.requestExecutionTimeMS
                });
            default:
                return new SSOAPIUnexpectedResponseBody(responseAPIContext, 'UI configuration error. Not filtering for the required status codes above.', {
                    requestStartTimeMS: response.requestStartTimeMS,
                    requestEndTimeMS: response.requestEndTimeMS,
                    requestExecutionTimeMS: response.requestExecutionTimeMS
                });
        }
    }
}
